import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const auditLogRoutes: RouteRecordRaw[] = [
  {
    path: '/audit-log',
    name: 'audit-log',
    component: () => import('@/modules/audit-log/views/AuditLogListView.vue'),
    meta: {
      permission: PERMISSIONS.AUDIT.VIEW,
    },
  },
  {
    path: '/audit-log/entity/:entityType/:entityId',
    name: 'audit-log-entity-timeline',
    component: () => import('@/modules/audit-log/views/AuditLogEntityTimelineView.vue'),
    meta: {
      permission: PERMISSIONS.AUDIT.VIEW,
    },
  },
]
